import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION } from '../constants/RestApiConstants';

// /users/me/ — caller-only endpoint; the server resolves the user from auth.
// See [[project_packages_users_me_pattern]].
const USER_PACKAGE_PREFERENCES_PATH = 'users/me/package-preferences';

export interface ISetUserPackagePreferenceRequest {
  userPackagePreferenceRequest: { enabled: boolean };
}

export interface ISetUserPackagePreferenceResponse {
  package?: IPackage;
}

export class SetUserPackagePreferenceService {
  public static setUserPackagePreference(packageLuid: string, enabled: boolean): Promise<ISetUserPackagePreferenceResponse> {
    return makeJsonRestApiRequest<ISetUserPackagePreferenceRequest, ISetUserPackagePreferenceResponse>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'PUT',
        endpoint: `${USER_PACKAGE_PREFERENCES_PATH}/${packageLuid}`,
      },
      request: { userPackagePreferenceRequest: { enabled } },
    });
  }
}
